import React from "react";
import { Row, Col } from "react-bootstrap";
// import { Link } from "react-router-dom";
import useMenu from "../../../../hooks/useMenu";
import "./Menu.css";


const Menu = () => {

  const { categoryItems, menuItems } = useMenu();

  return (
    // <div data-aos="zoom-in menu-content-main"
    // data-aos-easing="ease-out-cubic"
    // data-aos-duration="2000" className="menupage pb-0">

    // </div>
    <div className="menu-content">
      <div className='contact-banner'>
        <div className='contact-overlay'></div>
        <div className='contact-div'>
          <h1>Our Menu</h1>
          {/* <p>Home Page <span className='mx-2'>{">"}</span>Contact Us</p> */}
        </div>
      </div>
      <div className="py-5 px-md-5 menu-items">
        <Row className="gx-0 gy-3 px-md-5" xs={1}>
          {categoryItems.map((categoryItem, index) =>
            <Col key={index} xs={12} md={10} className="mx-auto">
              <div className="food-menu-grid-item-content">
                <h2 className=" menu_title text-center">{categoryItem?.title}</h2>
                <div className="food-menu-content">
                  {
                    menuItems.filter((menuItem) => menuItem?.category?.title === categoryItem?.title).map((item, index) => (
                      <div key={index}>
                        <div className="dot-div"></div>
                        <div className="text-div">
                          <span className="text-span">{item?.title}</span>
                          <span className="text-span pull-right">{item?.price} €</span>
                        </div>
                        <div className="food-item-description">
                          <p>{item?.description}</p>
                        </div>
                      </div>
                    ))
                  }
                </div>
              </div>
            </Col>
          )}


        </Row>
      </div>
      {/* <div className="py-3 py-md-5 text-center ">
          <a target="_blank" href="https://drive.google.com/file/d/1kJ96xS7ouFyZBpNRPvnBDryDwoZExmXL/view?usp=sharing" className="animated-button victoria text-center text-capitalized">See Full Menu</a>
        </div> */}
    </div>
  );
};

export default Menu;
